import { NAMESPACE } from "./catalog";
import type { FileMap } from "./datapack";
import type { BinaryFileMap } from "./resourcepack";

const encoder = new TextEncoder();

export function buildFabricMod(datapack: FileMap, resourcepack: BinaryFileMap, version: string): BinaryFileMap {
  const files: BinaryFileMap = {
    "fabric.mod.json": encoder.encode(JSON.stringify({
      schemaVersion: 1,
      id: NAMESPACE,
      version,
      name: "My Mods",
      description: "Made with mods.maniginam.dev",
      environment: "*",
      depends: { fabricloader: ">=0.16.0", minecraft: ">=1.21.11", "fabric-api": "*" },
    }, null, 2)),
  };
  for (const [path, text] of Object.entries(datapack)) if (path !== "pack.mcmeta") files[path] = encoder.encode(text);
  for (const [path, bytes] of Object.entries(resourcepack)) if (path !== "pack.mcmeta") files[path] = bytes;
  return files;
}
